import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import CaraoselVenue from 'assets/images/carousel-venue.jpeg';
import CaraoselVilla from 'assets/images/carousel-villa.jpg';

export default function Swiper() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <Carousel
      className="carousel-products mt-3"
      id="carouselProducts"
      controls={false}
      interval={3000}
      indicators
      style={{ color: "#696969" }}
    >
      {/* ITEM 1 */}
      <Carousel.Item>
        {isMobile ? (
          // ✅ Tampilan untuk MOBILE
          <div className="d-flex flex-column align-items-center text-center">
            <img
              src={CaraoselVenue}
              alt="carousel-venue"
              className="d-block w-100"
              style={{
                objectFit: 'cover',
                height: '60vh',
              }}
            />
            <div className="p-4">
              <h2 className="fw-600 line-height-1 mb-3">Venue Event</h2>
              <h1
                className="fw-600 line-height-1 mb-3"
                style={{ color: "#333333" }}
              >
                Venue Ideal untuk Setiap Momen.
              </h1>
            </div>
          </div>
        ) : (
          // ✅ Tampilan untuk DESKTOP (ASLI, TIDAK DIUBAH)
          <div className="d-flex align-items-center">
            <div className="col-md-6 text-content p-5">
              <h2 className="fw-600 line-height-1 mb-3">Venue Event</h2>
              <h1
                className="fw-600 line-height-1 mb-3"
                style={{ color: "#333333" }}
              >
                Venue Ideal untuk Setiap Momen.
              </h1>
            </div>
            <div className="col-md-6">
              <img
                src={CaraoselVenue}
                className="d-block w-100"
                alt="carousel-venue"
              />
            </div>
          </div>
        )}
      </Carousel.Item>

      {/* ITEM 2 */}
      <Carousel.Item>
        {isMobile ? (
          // ✅ Tampilan MOBILE
          <div className="d-flex flex-column align-items-center text-center">
            <img
              src={CaraoselVilla}
              alt="carousel-villa"
              className="d-block w-100"
              style={{
                objectFit: 'cover',
                height: '60vh',
              }}
            />
            <div className="p-4">
              <h2 className="fw-600 line-height-1 mb-3">
                Villa Green Hill Kemuning
              </h2>
              <h1
                className="fw-600 line-height-1 mb-3"
                style={{ color: "#333333" }}
              >
                Ketenangan Alam dan Kenyamanan.
              </h1>
            </div>
          </div>
        ) : (
          // ✅ Tampilan DESKTOP (ASLI)
          <div className="d-flex align-items-center">
            <div className="col-md-6 text-content p-5">
              <h2 className="fw-600 line-height-1 mb-3">
                Villa Green Hill Kemuning
              </h2>
              <h1
                className="fw-600 line-height-1 mb-3"
                style={{ color: "#333333" }}
              >
                Ketenangan Alam dan Kenyamanan.
              </h1>
            </div>
            <div className="col-md-6">
              <img
                src={CaraoselVilla}
                className="d-block w-100"
                alt="carousel-venue"
              />
            </div>
          </div>
        )}
      </Carousel.Item>
    </Carousel>
  );
}
